import { createElementFromHTML } from '../../utilities/js/helper';

class AddToCart {
    constructor ($element) {
        this.$addToCartContainer = $element;
        this.fetchUrl = this.$addToCartContainer.dataset.addToCartContentUrl;
        this.$parentTeaser = this.$addToCartContainer.closest('.termin-teaser');
        this.$loadingSpinner = createElementFromHTML(window.OPTIONS.loader);
        this.initialize();

        window.addEventListener('add_to_cart.reloaded', (e) => {
            if (this.$addToCartContainer === e.detail.$context) {
                this.initialize();

                this.$parentTeaser = e.detail.$context.closest('.termin-teaser');

                if (this.$parentTeaser !== null) {
                    this.$parentTeaser.classList.add('in--cart');
                }

                window.addEventListener('modal.closed', (e) => {
                    this.$linkToCart = this.$addToCartContainer.querySelector('a');

                    if (this.$linkToCart) {
                        setTimeout(() => {
                            this.$linkToCart.focus();
                        }, 400);
                    }
                });
            }
        });
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.$addToCartBtn = this.$addToCartContainer.querySelector('[data-termin-teaser="add-to-cart"]');

        if (this.$addToCartBtn) {
            this.$addToCartBtn.addEventListener('click', () => {
                this.fetchContentFromFetchUrl();
            });

            // open modal on enter or space key
            this.$addToCartBtn.addEventListener('keydown', (e) => {
                if (e.code === 'Enter' || e.code === 'Space') {
                    e.preventDefault();
                    this.fetchContentFromFetchUrl();
                }
            });
        }
    }

    updateCartCount () {
        const $cartItemsCount = this.$addToCartContainer.querySelector('[data-cart-count]');
        const cartCount = $cartItemsCount ? parseInt($cartItemsCount.dataset.cartCount, 10) : 0;
        const $$shopBasketIndicator = document.querySelectorAll('[data-basket]');

        if ($$shopBasketIndicator.length > 0) {
            $$shopBasketIndicator.forEach($shopBasketIndicator => {
                if (cartCount === 0) {
                    $shopBasketIndicator.classList.remove('is--active');
                } else {
                    $shopBasketIndicator.classList.add('is--active');
                }

                $shopBasketIndicator.textContent = cartCount;
            });
        }
    }

    fetchContentFromFetchUrl () {
        this.$addToCartBtn.appendChild(this.$loadingSpinner);

        fetch(this.fetchUrl, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(response => {
                if (!response.ok && response.status !== 422) {
                    throw new Error(`HTTP ERROR: ${response.status}`);
                }
                return response.text();
            })
            .then(data => {
                if (data) {
                    this.$addToCartContainer.innerHTML = '';
                    const $addToCartContent = createElementFromHTML(data);
                    this.$addToCartContainer.innerHTML = $addToCartContent.innerHTML;

                    this.updateCartCount();

                    window.dispatchEvent(new CustomEvent('content.loaded', {
                        view: window,
                        bubbles: true,
                        cancelable: false,
                        detail: {
                            $context: this.$addToCartContainer
                        }
                    }));

                    window.dispatchEvent(new CustomEvent('add_to_cart.reloaded', {
                        view: window,
                        bubbles: true,
                        cancelable: false,
                        detail: {
                            $context: this.$addToCartContainer
                        }
                    }));
                }
            })
            .catch(error => {
                console.error('ERROR:', error);
                const $loader = this.$addToCartContainer.querySelector('[data-loader]');

                if ($loader) {
                    $loader.remove();
                }
            });
    }
}

export { AddToCart };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $$addToCart = $context.querySelectorAll('[data-add-to-cart="root"]');

    if ($$addToCart.length > 0) {
        $$addToCart.forEach(($addToCart) => {
            const addToCart = new AddToCart($addToCart); // eslint-disable-line
        });
    }
});
